var ValueJS = ValueJS || {};

ValueJS.Hotspot = function() {

    var _init = function() {

        $('.hotspot__pin').on('click', function(e) {
            let pin = $(this);

            if (_isPinActive(pin)) {
                _deactivatePin(pin);
            } else {
                _activatePin(pin);
            }
        });

        $('.accordion--hotspot .accordion-button').on('click', function(e) {
            let pin = $('.hotspot__pin[data-bs-target="'+ $(this).data('bs-target') +'"]');

            if (_isPinActive(pin)) {
                _deactivatePin(pin);
            } else {
                _activatePin(pin);
            }
        });
    }

    var _activatePin = function(pin) {
        pin
            .addClass('hotspot__pin--active')
            .siblings('.hotspot__pin--active')
            .removeClass('hotspot__pin--active');
    }

    var _deactivatePin = function(pin) {
        pin.removeClass('hotspot__pin--active');
    }

    var _isPinActive = function(pin) {
        return pin.hasClass('hotspot__pin--active');
    }

    /** PUBLIC API **/
    return {
        init : function() {return _init();},
    };

}();

$(function() {
    ValueJS.Hotspot.init();
});
